// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';

// Import all "page" components
import HomePage from '@/views/HomePage.vue';
import LoginPage from '@/views/LoginPage.vue';
import AskAIPage from '@/views/AskAIPage.vue';
import ContextPage from '@/views/ContextPage.vue';
import LoadingPage from '@/views/LoadingPage.vue';
import ResponsePage from '@/views/ResponsePage.vue';

// Example function to check token validity
function isTokenValid() {
  const token = localStorage.getItem('auth_token');
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp && Date.now() < payload.exp * 1000;
  } catch (e) {
    return false;
  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/ask-ai',
    name: 'AskAI',
    component: AskAIPage,
  },
  {
    path: '/context',
    name: 'Context',
    component: ContextPage,
  },
  {
    path: '/loading',
    name: 'Loading',
    component: LoadingPage,
  },
  {
    path: '/response',
    name: 'Response',
    component: ResponsePage,
  },
];

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Example: If token is valid, skip Home page
router.beforeEach((to, from, next) => {
  if (to.path === '/' && isTokenValid()) {
    // If user has a valid token, skip home and go to ask-ai
    return next('/ask-ai');
  }
  next();
});

export default router;
